import moment from "moment";
import currencyFormatter from "../../helpers/currencyFormatter";

const columns = [
  {
    name: "Operator Name",
    selector: "operatorName",
    sortable: true,
    width: "200px",
  },
  {
    name: "Score",
    selector: "composedScore",
    sortable: true,
    width: "120px",
  },
  {
    name: "Country",
    selector: "country",
    sortable: true,
    width: "150px",
  },
  {
    name: "Signed OFRs",
    selector: "signedOfrs",
    sortable: true,
    width: "120px",
    cell: (row) => {
      if (
        row?.signedOfrs &&
        !isNaN(row?.signedOfrs)
      ) {
        return row.signedOfrs;
      }

      return "N/A";
    },
  },
  {
    name: "Total Price",
    selector: "totalPrice",
    sortable: true,
    width: "150px",
    cell: (row) => {
      if (
        row?.signedOfrs &&
        !isNaN(row?.signedOfrs)
      ) {
        return currencyFormatter.format(row.totalPrice);
      }

      return "N/A";
    },
  },
  {
    name: "Cities",
    selector: "cities",
    sortable: true,
    width: "150px",
  },
  {
    name: "Restrictions",
    selector: "restrictions",
    sortable: true,
    width: "200px",
    cell: (row) => {
      let restrictions = [];
      if (row?.restrictions?.length) {
        restrictions = row.restrictions.flatMap((item) => {
          let label = [];
          if (item === "caution") {
            label = "Use With Caution";
          }

          if (item === "blacklist") {
            label = "Blacklist";
          }

          if (item === "recovery") {
            label = "Recovery Only";
          }

          return label;
        });

        return restrictions.join(", ");
      }
    },
  },
  {
    name: "Updated At",
    selector: "updatedAt",
    sortable: true,
    width: "200px",
    cell: (row) => {
      return moment(row.createdAt).format("llll");
    },
  },
];

export default columns;
